import * as z from "zod";

export const getFaireIntegration = {
  name: "getFaireIntegration" as const,
  input: z.object({}),
  output: z.object({ exists: z.boolean(), enabled: z.boolean().optional() }),
};
